import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OneTimeDirective } from './one-time.directive';


@NgModule({
    declarations: [OneTimeDirective],
    imports: [
        CommonModule
    ],
    exports: [OneTimeDirective]
})
export class OneTimeModule {}
